import { render, staticRenderFns } from "./downloadClient.vue?vue&type=template&id=40a13b7d&scoped=true&lang=pug"
import script from "./downloadClient.vue?vue&type=script&lang=js"
export * from "./downloadClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a13b7d",
  null
  
)

export default component.exports